import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
const faqs = [{
  q: '¿El material es físico o digital?',
  a: 'El material es 100% digital. Vas a poder acceder desde tu celular, tablet o computadora en cualquier momento.'
}, {
  q: '¿Dónde voy a recibir el material?',
  a: 'Una vez realizado el pago, vas a recibir un correo electrónico con el acceso inmediato a todo el contenido y los bonos.'
}, {
  q: '¿Por cuánto tiempo tengo acceso?',
  a: 'El acceso es de por vida. Podés leerlo a tu propio ritmo y volver a consultarlo cada vez que lo necesites.'
}, {
  q: '¿Funciona si ya probé todo?',
  a: "Sí. Nuestro método se enfoca en entender las necesidades reales de tu bebé y establecer rutinas respetuosas, no en 'fórmulas mágicas' que no se adaptan a la realidad."
}, {
  q: '¿Cómo accedo al contenido?',
  a: 'Es muy simple: hacés clic en el botón de compra, completás tus datos, realizás el pago seguro y automáticamente te llega el acceso a tu email.'
}, {
  q: '¿Qué pasa si no me funciona?',
  a: 'Podés probar el método sin riesgo. Si no ves resultados, podés solicitar garantía dentro de los 7 días de la compra.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="bg-cream" data-id="element-72">
      <Section className="max-w-3xl" data-id="element-73">
        <SectionTitle data-id="element-74">Preguntas frecuentes</SectionTitle>

        <div className="mt-12 space-y-4" data-id="element-75">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-beige-muted rounded-xl overflow-hidden transition-all duration-200" data-id="element-76">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-77">
                <span className="font-bold text-charcoal pr-8" data-id="element-78">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-sage-dark flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-79" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-80">
                <p className="text-charcoal-light" data-id="element-81">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </Section>
    </div>;
}